var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCheckExclamation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.8401 3.44711C14.1454 3.727 14.1661 4.20143 13.8862 4.50677L6.55282 12.5068C6.4146 12.6576 6.22077 12.7454 6.01625 12.7498C5.81174 12.7542 5.61428 12.675 5.46963 12.5303L2.1363 9.19697C1.8434 8.90408 1.8434 8.4292 2.1363 8.13631C2.42919 7.84342 2.90406 7.84342 3.19696 8.13631L5.9764 10.9158L12.7804 3.49318C13.0603 3.18784 13.5347 3.16721 13.8401 3.44711Z",
    fill: "#78BE20"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 3.75V8.75M17 11.75C17 12.0261 16.7761 12.25 16.5 12.25C16.2239 12.25 16 12.0261 16 11.75M17 11.75C17 11.4739 16.7761 11.25 16.5 11.25C16.2239 11.25 16 11.4739 16 11.75M17 11.75H16",
    stroke: "#EE0000",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckExclamation);
export default __webpack_public_path__ + "static/media/checkExclamation.38400aa95d16e4cd9e825bb0c688dfeb.svg";
export { ForwardRef as ReactComponent };